export enum MessageSubscriptionEnum {
	None,
	Everyone,
	Following,
}
